import Alpine from "alpinejs";
import Clipboard from "@ryangjchandler/alpine-clipboard"
import resize from '@alpinejs/resize'


Alpine.plugin(resize);
Alpine.plugin(Clipboard);

Alpine.store('modalOpen', false);
Alpine.store('modalContent', '');

window.Alpine = Alpine;
